module.exports =  {
  TITLE: {
    default: 'Search Hotel|Tens of thousands of hotels in Asia online for reservation',
    detail: '|Hotel Reservation',
  },
  hotel: {
    // 酒店搜索改版新增翻译--韩文
    ROOMS: '침실 수',
    GUESTS: '인원수',
    CHECK_IN_NUM: '인원수',
    PREFIX_ADULTS: '성인',
    SUFFIX_ADULT: '명',
    SUFFIX_ADULTS: '명',
    PREFIX_CHILDREN: '어린이',
    SUFFIX_CHILD: '명',
    SUFFIX_CHILDREN: '명',
    CHILD_AGE: '어린이 나이',
    NO_MATCH_TIPS: '침실 수”, “인원수” 필터 기준에 맞추지 않은 침실은 다음과 같다.',

    Book_Hotel: 'Book Hotel',
    Select_your_destination: 'Select your destination',
    Please_enter_your_destination: 'Please enter your destination/hotel',
    Booked_up: 'Booked up',
    Hotel_description: 'Hotel description',
    Check_in_date: '체크인 날짜',
    Check_out_date: '체크아웃 날짜',
    Sold_out: 'Sold out',
    Non_refundable: 'Non-refundable',
    reserve: 'Book',
    Pay_Online: '온라인 지불',
    Only_rooms_left_before: 'Only',
    Only_rooms_left_after: 'room(s) left',
    Cancellation_Policy: '취소정책',
    See_all_prices_before: 'See all ',
    See_all_prices_after: 'prices',
    Estimated_time_of_arrival: '도착시간',
    make_your_schedule_well_planned: 'Time is for local time zone, please make your schedule well-planned and arrive on time.',
    Hotel_Not_Found: 'Hotel Not Found',
    Please_change_your_search: 'Please change your search',
    Submit_an_application: 'Submit an application',
    Hotel_Confirmation: '호텔 확인',
    Many_Night_Stay_before: '',
    Many_Night_Stay_after: '-Night Stay',
    Hotel_Booking_Number: '호텔 예약번호',
    Online_Payment: 'Online Payment',
    The_guest_Room_before: '입주자[객실',
    The_guest_Room_after: ']',
    Contact_number: '연락처',
    Bring_all_valid_IDs: 'Please bring all valid IDs of all guests when checking in.',
    Hotels_Found_before: '',
    Hotels_Found_after: '개 호텔을 찾았습니다',
    Hotels_Presented_before: '총',
    Hotels_Presented_center: 'Hotels Presented (',
    Hotels_Presented_after: ' 박)',
    Please_change_the_dates: 'Room not available on your dates, please change the dates.',
    Login: 'Log in on the APP to book hotel',
    Nights_in_total_before: '',
    Nights_in_total_after: 'Nights in total',
    Location: 'Location',
    Pictures: 'Pictures',
    Description: 'Description',
    Policy: 'Policy',
    Check_in_and_check_out_time: 'Check- in and check-out time',
    Check_in_and_Check_out_before: 'Check-in: after ',
    Check_in_and_Check_out_center: 'Check-out: before ',
    Check_in_and_Check_out_after: '',
    Check_in_time: '체크인',
    Check_out_time: '체크아웃',
    Hotel_Information: '기본 정보',
    Opening_Date: '개업일',
    Renovation_Date: '리모델링일',
    Facility_Service: 'Facility & Service',
    Payment_methods: 'Payment methods accepted by the hotel',
    Hotel_Address: 'Hotel Address',
    Pay_online: '온라인 지불',
    Pay_offline: 'Pay offline',
    Night_stay_before: '',
    Night_stay_after: '-Night Stay,',
    Rooms_total_before: 'Rooms',
    Rooms_total_after: 'in total',
    Guest_name_must_be_provided: 'The full guest name must be provided.',
    Please_fill_in_your_contact_number: '연락번호를 입력해 주십시오',
    Select_estimated_time_of_arrival: '예상 도착시간을 선택하십시오',
    Number_of_Rooms: '객실 수',
    Maximum_guests_per_room_before: 'Maximum ',
    Maximum_guests_per_room_after: ' guests per room',
    Many_Rooms: ' Rooms',
    Service_Fee_Included: '(Tax & Service Fee Included)',
    Last_Name: '성씨 병음',
    First_Name: '명 병음',
    Room: '객실 유형',
    Additional_Tax: '별납세금',
    Please_inform_the_hotel: 'If you were to arrive beyond estimated arrival time, please inform the hotel in advance.',
    Please_inform_the_hotel_first: 'Arrival at the hotel beyond the estimated arrival time without contacting the hotel in advance will affect the availablity of the room and dinner. Please inform the hotel first to confirm the availablity in such circumstance.',
    Booking_Cancellation: 'Booking Cancellation',
    Reason_of_Cancellation: 'Reason of Cancellation',
    Incorrect_Information_Filled: 'Incorrect Information Filled',
    Itinerary_Changed: 'Itinerary Changed',
    Lower_price_on_other_APP: 'Lower price on other APP',
    Low_quality_hotel: 'Low-quality hotel',
    Book_at_a_lower_price: 'Book at a lower price at the front desk',
    Other: 'Other',
    Please_write_your_reason: 'Please write your reason',
    After_cancellation_done: 'After cancellation done, the payment will be returned to the original payer within 3 working days.',
    How_to_fill_in_the_guest_name: '입주자 성명 작성 설명',
    It_should_be_exactly_the_same: '호텔 예약은 입주자의 이름을 반드시 영문으로 기입해야 하며,체크인할 때 제출한 서류와 정확히 일치해야 합니다.',
    How_to_fill_in_a_Chinese_name: '중국어 이름 기입 방식:',
    How_to_fill_in_a_English_name: '영어 이름 기입 방식:',
    For_example: '예를들면: “韩梅梅”，성씨는 “Han”를 기입하고 명은 “Meimei”를 기입합니다',
    No_specical_characters: '① 영문 이름에는 숫자 또는 특수 기호를 포함할 수 없습니다.',
    Name_rule_first: '② 성은 앞에 있고, 이름은 뒤에 있고, 중간 이름이 있으면 빈칸 한 개 비어서 명의 뒤에 씁니다',
    Name_rule_second: '예를들면:Green/ Jim Stephanie',
    Details: 'Details',
    Pay_now: 'Pay now',
    Hotel: 'Hotel',
    Check_in: 'Check  in',
    Car: 'Car',
    All_bookings: 'All bookings',
    All: 'All',
    PROMPT: 'Attention',
    NETWORK_TIMEOUT: '네트워크 시간 초과입니다. 주문을 다시 제출해 주세요',
    ORDER_SUBMIT_SLOW: '주문을 제출하는 중입니다. 잠시만 기다려 주세요(공급업체 확인에 시간이 걸릴 수 있습니다. 페이지를 닫거나 다시 제출하지 마세요)',
    ORDER_SUBMIT_UNKNOWN: '주문 결과를 확인할 수 없습니다. "내 주문"에서 접수 여부를 확인해 주세요. 중복 주문하지 마세요',
    REQUEST_FAIL: '요청에 실패했습니다. 잠시 후 다시 시도해 주세요',

    Search: '검색',
    COST_DESCRIPTION: 'Price Detail',
    TOTAL: 'Total',
    SEE_ORDER_INFO_TO: 'Pay',
    KONW: 'Got it',
    BOOKING_INFORMATION: 'Important Information',
    Book_Now: 'Pay It Now',
    MAP: 'Map',
    CONTACT_INFORMATION: 'Contact Information',
    LOADING: 'Loading...',
    SORT_FILTER: 'Sort/Filter',
    SCREENING: 'Filter',
    SEQUENCE: '순서',
    PHONE_ASK: 'Call us',
    ABOVE: '',
    SUBMINT_ORDER: '제출',
    OK: 'OK',
    Order_detail: 'Order details',
    BOOKING_INFO: '주문 정보',
    PAYMENT_AMOUNT: '주문금액',
    Order_time: '예약 시간',
    ORDER_NUMBERS: '예약번호',
    PAY_TYPE: 'Payment Method',
    BALANCE: 'Balance',
    CURRENT_BALANCE_BEGIN: 'Balance',
    OVERPLUS_BALANCE_BEGIN: 'Remaining',
    OTHER_PAYMENT: 'Other payment methods',
    Unionpay: 'UnionPay',
    Wechatpay: 'WeChat Payment',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: 'Click on “Pay It Now” Means You Agree Upon Baigolf ',
    AGREE_SERVICE_AGREEMENT_AFTER: '',
    SERVICE_AGREEMENT: '《Service Agreement》',
    PAYMENT_ORDER: 'Booking Payment',
    Total_pay: 'Amount Due',
    PAY_SUCCESS: 'Payment Accepted',
    CHECK_THE_ORDER: 'Check the Order',
    BACK_TO_INDEX: 'Back to Index',
    CANCEL: '주문취소',
    RECOMMED: '추천',
    PRICE: '가격',
    HIGH: 'High',
    LOW: 'Low',
    RESET: 'Reset',
    SELECT_TIME: 'Select Date',
    Hotel_guest: '입주자',
    Select: 'Please Select',
    Emial_address: '이메일 주소를 입력해 주십시오',
    Booking_explan: '예약설명',
    VIEW_MORE: 'View more',
    COLLAPSE: 'Hide',
    Week: '',
    Month: '',
    TOURISM_CHECK_IN_HOTEL: '체크인',
    TOURISM_LEAVE_HOTEL: '체크아웃',
    arrive: '목적지',
    Room_description: '객실 설명',
    Meals: '식사',
    Room_Type: '객실 유형',
    BOOKING_EXPLANATION: '예약 설명',
    BOOKING_BUTTON: '예약',
    REMIND_SUBMIT_ORDER: '예약',
    login_now: 'Hotel reservations need to log in, login now?',
    the_real_scene: 'Pictures are for reference only and subject to the real scene.',
    Bed: '침대 유형',
    Rooms: 'Room',
    Room_rate: '객실 요금',
    notified_by_SMS: '예약이 완료되면 메시지를 보내드릴겠습니다',
    email_notifications: '이메일 알림 수신에 사용',
    Booking_deadline: '마감 예약 시간',
    Child: '어린이',
    Additional_notes_about_payment: 'Additional notes about payment',
    Nights: 'Nights',
    Minimum_nights_before: 'Minimum',
    Minimum_nights_after: 'nights',
    Size: '면적',
    Guests: '인원수',
    Room_rate_1: '객실 요금',
    Tax_service_fee: '세금/서비스료',
    Pay_now_1: 'Pay now',
    Filter: 'Filter',
    Room_rate2: '객실 요금',
    Show_on_map: '지도 보기',
    Detail: '자세한 내용 보기',
    Room_Detail: '자세한 내용 보기',

    TAXES_INCL: '세금포함총액',
    SEARCH_EMPTY_TIP: '죄송합니다.선택한 날짜에 빈 방이 없습니다.당신은 다른 날짜를 검색할 수 있고;또는 다른 호텔을 검색할 수 있습니다.',
    severalNight: 'Nights',
    immediateBooking: '즉시 예약',
    Refundable: '취소조건',
    MORE: '더 보기',
    adultsCompany: '명성인',
    ServiceTerms: '입주약관',
    roomPlan: 'Plan',
    guestRoom: '침실',
    searchAgain: '다시 검색',
    roomNight: '칸/밤',

    NAME_TXT: '이름',
    HOLDER_NAME: '카드 소지자 이름',
    EXPIRATION_DATE: '만기일',
    FORMAT_TXT: '향식',
    SECURITY_CODE: '안전코드',
    MASTER_CARD_NAME: 'Master Card',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: '카드 뒤에 3자리 숫자',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: '카드 앞면의 4자리',
    ENTER_COMPLETE_CARD_NUM: '카드번호 입력해 주십시오',
    PLEASE_ENTER_HOLDER_NAME: '카드 소지자 이름 입력해 주십시오.',
    ENTER_SECURITY_CODE: '안전코드 입력해 주십시오.',
    ENTER_EXPIRATION_DATE: '만기일 입력해 주십시오',
    ROOM_DETAILS: '객실  상세한 정보',
    CONDITION_CANCEL: '취소조건',
    CHOOSE_PAYMENT_METHOD: '지불수단선택',
    ORDER_TOTAL_LUMP: '예약 신청 총금액',
    CREDIT_CARD_NUM: '지불카드/신용카드번호',
    MAINLAND_CARD_ONLY: '중국대륙 이외 지역에서 발행되는 은행 카드만 가능합니다.',
    SHUT_DOWN: '샷 다운',
    PROVIDER_FROM_CHINA_BANK: '중국 은행에서 지불 서비스를 제공합니다.',

    COUPON: '할인권',
    APPLY_A_COUPON: '쿠폰 등록',
    NO_USE: '결제한 상품 사용불가',
    Discard: 'Discard',
    REDEEM: '환전',
    EMPTY_COUPON: '할인권 번호를 입력하세요.',
    NOTICE_COUPON: '1회 1장의 할인권을 사용하실 수 있으며 사용하신 할인권은 중복 사용하실 수 없습니다.',

    BREAKFAST_INCLUDE: 'breakfast include',
    BREAKFAST_EXCLUDE: 'breakfast exclude',
    DOUBLE_BED: 'double bed',
    TWIN_BED: 'twin bed',
    FREE_CANCEL: 'free cancellation',
    MEALS: 'meals',
    EVALUATION: 'Review',
    FEATURED_REVIEWS: '추천 댓글',
    ALL_REVIEWS: '전부 댓글',
    OVERALL_EVALUATION: '전체 평가',
    ANONYMOUS: '익명',
    EVAL_GENERAL_LIST_1: '매우 좋지 않음',
    EVAL_GENERAL_LIST_2: '좋지 않음',
    EVAL_GENERAL_LIST_3: '일반',
    EVAL_GENERAL_LIST_4: '좋음',
    EVAL_GENERAL_LIST_5: '매우 좋음',
    MAX_IMAGES_WITH_NINE: 'A maximum of 10 pictures can be selected.',
    GRADE_EVAL: '전체 평가를 선택해주세요.',
    DISTANCE_FILTER: 'distance close-far',
    EDIT_EVALUATION: 'give comments',
    GO_TO_EVAL: 'give comments',
    EVAL_POINTS_AWARD: 'Good comments can win 1000points,1000 points=10RMB',
    NEARBY_LIKE_HOTEL: 'similar hotel nearby',
    DISTANCE_HOTEL: 'to hotel',
    PLEASE_ENTER_COMMENT: 'comments',
    AWARD_POINTS_TIPS: 'Best comments can get 1000 points 1000=10RMB',
    NO_SHOW_ANONYMOUS_AVATAR: 'Anonymous comments will not show your logo and name',
    LOCATION: 'location',
    FACILITY: 'facility',
    SERVICE: 'service',
    HEALTH: 'clean',
    LANGUAGE_SELECT: 'language',
    LIMIT_COMMENT_TXT: '평론의 글자수는 5~2000 자 내입니다.',
    SHARE_MEDIA: 'Share pics and video',
    SETTLEMENT_FEEL: 'Comments',
    SUBMIT_EVAL: '확인',
    HOTEL_STR: '상세',
    EVAL_NUM_AFTER: '개 평가',
  },
  header: {
    SKIING: 'Ski resort',
    header_internal_call: '중국：',
    header_abroad_call: '해외：',
    header_app_download: '휴대전화 버젼',
    service_telephone: '고객센터',
    account_number: '계정',
    if_bg_user: '아직 BaiGolf 회원이 아니십니까？',
    home: '처음 페이지',
    hotel: '호텔',
    Golf: '골프',
    PLAY_STAY: '골프 + 숙박',
    RENT_CAR_HOME: 'Car',
    center_user: '회원센터',
    header_my_order: '나의 예약',
    header_notmember_order: '비회원 예약',
    header_edit_password: '비밀번호 변경',
    header_logout: '로그아웃',
    header_login: '로그인',
    header_register: '가입',
    header_point: '나의 마일리지',
    header_all_language: '모든 언어',
    down_load_app: 'QR코드로 다운로드',
    login_discount_tip: '로그인을 하시면 마일리지와 BaiGolf 만의 독자적인 혜택을 누리실 수 있습니다',
    currency_balance_limit: '현재 통화에 잔액이 남아 있어 통화를 전환할 수 없습니다'
  },
  footer: {
    footer_partner: '제휴업체',
    footer_about_us: '회사 소개',
    footer_about_baigolf: 'BaiGolf.com에 대해',
    footer_privacy_policy: 'BaiGolf.com 개인정보 취급방침',
    footer_use_of_terms: 'BaiGolf.com 이용약관',
    footer_contact_us: '고객 서비스 센터',
    footer_sitemap: 'Sitemap',
    footer_use_of_question: '자주묻는질문',
    footer_ios_system: 'iOS 시스템',
    footer_android_system: '안드로이드 시스템',
    footer_app_load: 'APP 다운로드',
    footer_sina_weibo: '新浪微博(시나웨이보)',
    footer_tencent_weibo: '腾讯微博(텅쉰웨이보)',
    footer_share_to: '공유하기',
    copyright1: 'BaiGolf.com에 모든 판권이 있습니다.',
    copyright2: '粤ICP备14070002号',
    news_center: '뉴스센터',
    about_baigolf: 'BaiGolf.com에 관하여',
    help: '고객센터',
    management_system: 'BG Golf Management System (BGMS)',
    wechat_official_account: '위챗 공식 계정을 팔로우',
    download_baiGolf_app: 'Download BaiGolf App',
    privacy_policy: '개인정보 취급방침',
    use_of_terms: '이용약관',
    footer_integral: '마일리지 적립 약관',
    footer_reserve: '예약 조항',
    footer_abroad_call: '해외',
    footer_internal_call: '중국'
  }
}



// WEBPACK FOOTER //
// ./src/lang/ko_kr.js